<template>
  <div class="b-page__content-block b-contract__section pb-8">
    <div class="row px-0">
      <div class="col-2">
        <label for="number">
          {{ $t('CONTENT.contract.contract_number') }}:
          <span class="b-form__required">*</span>
        </label>
        <input
          id="number"
          v-model.lazy="number"
          type="text"
          class="b-input"
          name="number"
          required
          v-bind:class="{ 'b-form__field-error': isFieldWithError('number', number) }"
        />
      </div>
      <div class="col-2">
        <label>
          {{ $t('CONTENT.contract.contract_date') }}:
          <span class="b-form__required">*</span>
        </label>
        <datepicker v-bind:class="{ 'b-datepicker__error': isFieldWithError('date', date) }" class="b-datepicker"
                    v-model="date" :formatter="datepickerFormat"></datepicker>

      </div>
      <div class="col-2">
        <label for="externalId">{{ $t('CONTENT.external_id') }}:</label>
        <input
          type="text"
          id="externalId"
          class="b-input"
          name="externalId"
          v-model.lazy="externalId"
        />
      </div>
    </div>
    <div class="row mt-5 px-0 b-form__row_type_flex-end">
      <div class="col-4">
        <div class="b-form__container">
          <label>
            {{ $t('CONTENT.contract.lessee') }}:
            <span class="b-form__required">*</span>
          </label>
          <cool-select :list="counterparties"
                       option-value="id"
                       option-text="value"
                       :placeholder="$t('CONTENT.choose')"
                       :isError="isFieldWithError('currentLessee', currentLessee)"
                       v-model="currentLessee"></cool-select>
        </div>
      </div>
      <div class="pr-2">
        <button
          type="button"
          :data-cy="`add-counterparty-lessee`"
          class="b-btn b-btn_type_add"
          @click="openCounterPartyDialog"
        >
          <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="plus"></dynamic-icon>
        </button>
      </div>
      <button
        type="button"
        :data-cy="`import-counterparty-lessee`"
        class="b-btn b-btn_type_add"
        @click="openImportDialog"
      >
        <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="xls"></dynamic-icon>
      </button>
      <div class="b-contract__check mx-2 mb-2" v-if="checkIsCounterpartyIntragroup(currentLessee)">
        <dynamic-icon class="mr-2" icon="check"></dynamic-icon>
        {{ $t('CONTENT.counterparty.VGO') }}
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-3">
        <div class="b-form__container">
          <label>
            {{ $t('CONTENT.contract.lessor') }}:
            <span class="b-form__required">*</span>
          </label>
        </div>
      </div>
    </div>
    <div :key="counter">
      <div v-for="(item, index) in lessorsIds">
        <LessorRow
          :lessorIndex="index"
          :lessor="item"
          :lessorsIdsLength="lessorsIds.length"
          :isError="lessorsIds && lessorsIds.length - 1 === index ? isFieldWithError('lessor', item) : false"
          @selectLessor="selectLessor"
          @setNewLessor="setNewLessor"
          @openImportDialog="openImportDialog"
        ></LessorRow>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-4">
        <div class="b-form__container">
          <button
            type="button"
            @click="addLessor"
            data-cy="add-lessor"
            class="b-btn"
            :disabled="isDisabledAddLessor"
          >
            <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="plus"></dynamic-icon>
            {{ $t('CONTENT.contract.add_lessor') }}
          </button>
        </div>
      </div>
    </div>
    <div class="row px-0">
      <div class="col-2">
        <label for="number">
          {{ $t('CONTENT.contract.initiator') }}:
          <span class="b-form__required">*</span>
        </label>
        <input
          id="responsible"
          v-model.lazy="responsible"
          type="text"
          class="b-input"
          name="responsible"
        />
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-5">
        <checkbox class="b-checkbox" id="isLowValue" v-model="isLowValue" :disabled="isNotRentContract">
          {{ $t('CONTENT.contract.is_low_value') }}
        </checkbox>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-5">
        <checkbox class="b-checkbox" id="isExceptionToArticle3OfIFRS16" v-model="isExceptionToArticle3OfIFRS16"
                  :disabled="isNotRentContract">
          {{ $t('CONTENT.contract.isExceptionToArticle3OfIFRS16') }}
        </checkbox>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-5">
        <checkbox class="b-checkbox" id="isShortTerm" v-model="isShortTerm" :disabled="isNotRentContract">
          {{ $t('CONTENT.contract.isShortTerm') }}
        </checkbox>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-5">
        <checkbox class="b-checkbox" id="isIrrelevant" v-model="isIrrelevant" :disabled="isNotRentContract">
          {{ $t('CONTENT.contract.isIrrelevant') }}
        </checkbox>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-5">
        <checkbox class="b-checkbox" id="isVariableLeasePayments" v-model="isVariableLeasePayments"
                  :disabled="isNotRentContract">
          {{ $t('CONTENT.contract.isVariableLeasePayments') }}
        </checkbox>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-5">
        <checkbox class="b-checkbox" id="isNotRentContract" v-model="isNotRentContract">
          {{ $t('CONTENT.contract.isNotRentContract') }}
        </checkbox>
      </div>
    </div>
    <div class="row mt-2 b-contract__type-exception-error" v-if="isFieldWithError('typeException', false) && !isSelectedTypeException">
      <div class="col-5">
        <p>Необходимо выбрать вид исключения</p>
      </div>
    </div>
    <div class="mt-5" v-if="isShowAssetsForAdd">
      <div v-for="(lowValueAsset, lowValueAssetsIndex) in lowValueAssets">
        <LowValueAssets
          :lowValueAsset="lowValueAsset"
          :lowValueAssetsIndex="lowValueAssetsIndex"
          :settingsCurrencyCode="settingsCurrencyCode"
          :availableAssetIdsForGroup="availableAssetIds"
          :lowValueAssetsLength="lowValueAssets.length"
          :validationErrors="validationLowValueAsset[lowValueAssetsIndex]"
          @newAssetSelected="newAssetSelectedForGroup"
          @newAssetCreated="newAssetCreatedForGroup"
          @deleteAsset="onDeleteAsset"
        ></LowValueAssets>
      </div>
      <div class="row mt-5">
        <div class="col-3">
          <div class="b-form__container">
            <button
              type="button"
              class="b-btn"
              @click="addLowValueAsset"
            >
              <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="plus"></dynamic-icon>
              {{ $t('CONTENT.assets.add_asset') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-5 b-period-spendings" v-else-if="!isShowAssetsForAdd">
      <h4>{{ $t('CONTENT.contract.period_sprendings_title') }}</h4>
      <div v-for="(item, index) in periodSpendings" :key="index">
        <PeriodSpendingsItem
          :periodSpendingsItem="item"
          :periodSpendingsItemIndex="index"
          :periodSpendingsLength="periodSpendings.length"
          :systemCurrencyCode="settingsCurrencyCode"
          :validationErrors="validationPeriodSpendings[index]"
          @onDeletePeriodSpending="deletePeriodSpendingsItem($event)"
        ></PeriodSpendingsItem>
      </div>
      <div class="row mt-4">
        <div class="col-3">
          <div class="b-form__container">
            <button
              type="button"
              class="b-btn"
              @click="addPeriodSpendings"
              :disabled="isDisabledAddPeriodSpendings"
            >
              <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="plus"></dynamic-icon>
              {{ $t('CONTENT.contract.add_period') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <popup name="lessee-counterparty-popup" height="auto" :scrollable="true">
      <server-error :error="error"/>
      <GeneralForm
        v-if="isCounterPartyShow"
        :counterparty="counterpartyForForm"
        @createNewCounterparty="onCreateCounterparty"
        @close="closeCounterPartyDialog"
      />
    </popup>
    <popup name="counterparty-import-popup" height="auto" :scrollable="true">
      <ImportDialogWidget
        :importType="'counterparty'"
        v-if="isShowImportDialog"
        @close="closeImportDialog"
      ></ImportDialogWidget>
    </popup>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import datepickerFormat from '@/mixins/datepickerFormat.mixin';
import dateConverter from "../../../utils/converters/date.converter";
import PeriodSpendingsItem from "./PeriodSpendingsItem";
import GeneralForm from "../../directories/counterparty/edit/GeneralForm";
import ImportDialogWidget from "../../widgets/ImportDialogWidget";
import LessorRow from "../alternativeContracts/LessorRow";
import LowValueAssets from "./LowValueAssets";
import PeriodSpendings from "../../../models/alternativeContract/PeriodSpendings";
import LowValueAsset from "../../../models/alternativeContract/LowValueAsset";

export default {
  props: {
    validationErrors: {
      type: Array
    },
    validationPeriodSpendings: {
      type: Array
    },
    validationLowValueAsset: {
      type: Array
    }
  },
  components: {
    LessorRow,
    PeriodSpendingsItem,
    GeneralForm,
    ImportDialogWidget,
    LowValueAssets
  },
  mixins: [datepickerFormat],
  data() {
    return {
      counter: 0,
      error: null,
      periodSpendings: [],
      lowValueAssets: [],
      availableAssetIds: [],
      isCounterPartyShow: false,
      isShowImportDialog: false,
      counterpartyForForm: null,
      isDisabledAddLessor: true,
      isCounterPartyForLessorShow: false,
      isShowAssetsForAdd: false,
    };
  },
  created() {
    this.lowValueAssets = this.currentContract.lowValueAssets;
    if (this.lowValueAssets.length > 0 || this.isLowValue || this.isShortTerm || this.isVariableLeasePayments) {
      this.isShowAssetsForAdd = true;
    }
    this.periodSpendings = this.currentContract.periodSpendings;

    if (this.periodSpendings.length === 0 && this.lowValueAssets.length === 0) {
      this.addPeriodSpendings();
    }

    if (this.availableAssetIds.length === 0) {
      this.availableAssetIds = [...this.getAssets];
    }
  },
  watch: {
    isLowValue() {
      this.setIsShowAssetsForAdd();
    },
    isShortTerm() {
      this.setIsShowAssetsForAdd();
    },
    isVariableLeasePayments() {
      this.setIsShowAssetsForAdd();
    },
    isShowAssetsForAdd(newVal) {
      if (newVal) {
        this.periodSpendings = [];
        if (this.lowValueAssets.length === 0) {
          this.lowValueAssets.push(LowValueAsset.createNew());
        }

        this.$store.commit("EDIT_ALTERNATIVE_CONTRACT_VALUE", {
          name: "periodSpendings",
          value: this.periodSpendings
        });

        this.$store.commit("EDIT_ALTERNATIVE_CONTRACT_VALUE", {
          name: "lowValueAssets",
          value: this.lowValueAssets
        });
      } else {
        this.lowValueAssets = [];
        if (this.periodSpendings.length === 0) {
          this.periodSpendings.push(PeriodSpendings.createNew());
        }

        this.$store.commit("EDIT_ALTERNATIVE_CONTRACT_VALUE", {
          name: "lowValueAssets",
          value: this.lowValueAssets
        });

        this.$store.commit("EDIT_ALTERNATIVE_CONTRACT_VALUE", {
          name: "periodSpendings",
          value: this.periodSpendings
        });
      }
    }
  },
  computed: {
    ...mapGetters(["getCurrentAlternativeContract"]),
    ...mapGetters(["getCounterpartiresForContract"]),
    ...mapGetters(["getAlternativeKinds"]),
    ...mapGetters(["getContractSettings"]),
    ...mapGetters(["getAlternativeLessors"]),
    ...mapGetters(["allCounterparties"]),
    ...mapGetters(["getAssets"]),
    currentContract() {
      return this.getCurrentAlternativeContract;
    },
    settingsCurrencyCode() {
      return this.getContractSettings.currencyCode;
    },
    lessorsIds: {
      get() {
        if (this.getAlternativeLessors.length === 0) {
          return (this.lessorsIds = [""]);
        } else {
          if (
            this.getAlternativeLessors[
            this.getAlternativeLessors.length - 1
              ] === ""
          ) {
            this.isDisabledAddLessor = true;
          }
          return this.getAlternativeLessors;
        }
      },
      set() {
      }
    },
    currentLessee: {
      get() {
        if (this.currentContract.lesseeId === null) {
          this.$store.commit("EDIT_ALTERNATIVE_CONTRACT_VALUE", {
            name: "lesseeId",
            value: this.getContractSettings.systemOwnerCounterpartyId
          });
          return this.getContractSettings.systemOwnerCounterpartyId;
        } else {
          return this.currentContract.lesseeId;
        }
      },
      set(newVal) {
        this.$store.commit("EDIT_ALTERNATIVE_CONTRACT_VALUE", {
          name: "lesseeId",
          value: newVal
        });
      }
    },
    isDisabledAddPeriodSpendings() {
      for (let i = 0; i < this.periodSpendings.length; i++) {
        if (
          this.periodSpendings[i].startDate === null ||
          this.periodSpendings[i].endDate === null ||
          this.periodSpendings[i].sum === null
        ) {
          return true;
        }
      }

      return false;
    },
    number: {
      get() {
        return this.currentContract.number;
      },
      set(newVal) {
        this.$store.commit("EDIT_ALTERNATIVE_CONTRACT_VALUE", {
          name: "number",
          value: newVal
        });
      }
    },
    date: {
      get() {
        if (this.currentContract.date === null) {
          return null;
        } else {
          return dateConverter.convertToDate(this.currentContract.date);
        }
      },
      set(newVal) {
        let date = dateConverter.convertToString(newVal);
        this.$store.commit("EDIT_ALTERNATIVE_CONTRACT_VALUE", {
          name: "date",
          value: date
        });
      }
    },
    externalId: {
      get() {
        return this.currentContract.externalId;
      },
      set(newVal) {
        this.$store.commit("EDIT_ALTERNATIVE_CONTRACT_VALUE", {
          name: "externalId",
          value: newVal
        });
      }
    },
    responsible: {
      get() {
        return this.currentContract.responsible;
      },
      set(newVal) {
        this.$store.commit("EDIT_ALTERNATIVE_CONTRACT_VALUE", {
          name: "responsible",
          value: newVal,
        });
      }
    },
    isLowValue: {
      get() {
        return this.currentContract.isLowValue;
      },
      set(newVal) {
        this.$store.commit("EDIT_ALTERNATIVE_CONTRACT_VALUE", {
          name: "isLowValue",
          value: newVal
        });
      }
    },
    isExceptionToArticle3OfIFRS16: {
      get() {
        return this.currentContract.isExceptionToArticle3OfIFRS16;
      },
      set(newVal) {
        this.$store.commit("EDIT_ALTERNATIVE_CONTRACT_VALUE", {
          name: "isExceptionToArticle3OfIFRS16",
          value: newVal
        });
      }
    },
    isShortTerm: {
      get() {
        return this.currentContract.isShortTerm;
      },
      set(newVal) {
        this.$store.commit("EDIT_ALTERNATIVE_CONTRACT_VALUE", {
          name: "isShortTerm",
          value: newVal
        });
      }
    },
    isIrrelevant: {
      get() {
        return this.currentContract.isIrrelevant;
      },
      set(newVal) {
        this.$store.commit("EDIT_ALTERNATIVE_CONTRACT_VALUE", {
          name: "isIrrelevant",
          value: newVal
        });
      }
    },
    isVariableLeasePayments: {
      get() {
        return this.currentContract.isVariableLeasePayments;
      },
      set(newVal) {
        this.$store.commit("EDIT_ALTERNATIVE_CONTRACT_VALUE", {
          name: "isVariableLeasePayments",
          value: newVal
        });
      }
    },
    isNotRentContract: {
      get() {
        return this.currentContract.isNotRentContract;
      },
      set(newVal) {
        this.$store.commit("EDIT_ALTERNATIVE_CONTRACT_VALUE", {
          name: "isNotRentContract",
          value: newVal
        });

        if (newVal) {
          this.isExceptionToArticle3OfIFRS16 = false;
          this.isIrrelevant = false;
          this.isLowValue = false;
          this.isShortTerm = false;
          this.isVariableLeasePayments = false;
        }

        this.currentContract.isNotRentContract = newVal;
      }
    },
    isSelectedTypeException() {
      return this.isExceptionToArticle3OfIFRS16 || this.isIrrelevant || this.isLowValue
        || this.isShortTerm || this.isVariableLeasePayments || this.isNotRentContract;
    },
    counterparties() {
      return this.getCounterpartiresForContract;
    }
  },
  methods: {
    setIsShowAssetsForAdd() {
      this.isShowAssetsForAdd = !!(this.isLowValue || this.isShortTerm || this.isVariableLeasePayments);
    },
    addLessor() {
      this.$store.commit("ADD_ALTERNATIVE_LESSOR");
    },
    addPeriodSpendings() {
      this.periodSpendings.push(PeriodSpendings.createNew());

      this.$store.commit("EDIT_ALTERNATIVE_CONTRACT_VALUE", {
        name: "periodSpendings",
        value: this.periodSpendings
      });
    },
    addLowValueAsset() {
      this.lowValueAssets.push(LowValueAsset.createNew());

      this.$store.commit("EDIT_ALTERNATIVE_CONTRACT_VALUE", {
        name: "lowValueAssets",
        value: this.lowValueAssets
      });
    },
    async onCreateCounterparty(index) {
      this.setNewCounterparty(index);
    },
    async setNewCounterparty() {
      await this.$store.dispatch("getAllCounterparties");

      this.$store.commit("EDIT_ALTERNATIVE_CONTRACT_VALUE", {
        name: "lesseeId",
        value: this.getCounterpartiresForContract[0].id
      });
    },
    deletePeriodSpendingsItem(itemIndex) {
      this.periodSpendings.splice(itemIndex, 1);
    },
    async openImportDialog() {
      this.isShowImportDialog = true;
      this.$modal.show('counterparty-import-popup');
    },
    async closeImportDialog() {
      await this.$store.dispatch("getAllCounterparties");
      this.isShowImportDialog = false;
      this.$modal.hide('counterparty-import-popup');
    },
    openCounterPartyDialog() {
      this.isCounterPartyShow = true;
      this.$modal.show('lessee-counterparty-popup');
    },
    closeCounterPartyDialog() {
      this.isCounterPartyShow = false;
      this.counterpartyForForm = null;
      this.$modal.hide('lessee-counterparty-popup');
    },
    checkIsCounterpartyIntragroup(counterpartyId) {
      for (let i = 0; i < this.allCounterparties.length; i++) {
        if (this.allCounterparties[i].idInDB === counterpartyId) {
          return this.allCounterparties[i].isIntragroupTurnover;
        }
      }
    },
    setNewLessor(index) {
      this.lessorsIds[index] = this.getCounterpartiresForContract[0].id;
    },
    newAssetSelectedForGroup(data) {
      // Return previous asset to collection
      const oldAsset = this.getAssets.find(a => a.idInDB === data.old);
      const ckeckOldAsset = this.availableAssetIds.find(a => a.idInDB === data.old);
      if (ckeckOldAsset === null && oldAsset !== null) {
        this.availableAssetIds.push(oldAsset);
      }

      const choosenAsset = this.getAssets.find(a => a.idInDB === data.old);
      if (choosenAsset != null) {
        this.availableAssetIds.push(choosenAsset);
      }

      // remove new selected asset from collection if exist
      const neededAsset = this.availableAssetIds.find(a => a.idInDB === data.new);
      if (neededAsset !== null) {
        const neededAssetIndex = this.availableAssetIds.indexOf(neededAsset);
        this.availableAssetIds.splice(neededAssetIndex, 1);
      }
    },
    newAssetCreatedForGroup(data) {
      const newAsset = this.getAssets.find(a => a.idInDB === data.new);
      const oldAsset = this.getAssets.find(a => a.idInDB === data.old);
      this.availableAssetIds.push(newAsset);

      const ckeckOldAsset = this.availableAssetIds.find(a => a.idInDB === data.old);
      if (ckeckOldAsset === null) {
        this.availableAssetIds.push(oldAsset);
      }
    },
    onDeleteAsset(asset) {
      for (let i = 0; i < this.lowValueAssets.length; i++) {
        if (this.lowValueAssets[i].assetId === asset) {
          this.lowValueAssets.splice(i, 1);
        }
      }
      this.$store.commit("EDIT_ALTERNATIVE_CONTRACT_VALUE", {
        name: "lowValueAssets",
        value: this.lowValueAssets
      });
    },
    selectLessor(index, item) {
      this.isDisabledAddLessor = false;
      this.lessorsIds[index] = item;
    },
    isFieldWithError(field, value) {
      return !value && this.validationErrors && this.validationErrors.includes(field);
    }
  }
};
</script>

